/**
* @name: app-template-show
* @author: weiyong
* @date: 2023-04-03 15:06
* @description：app-template-show
* @update: 2023-04-03 15:06
*/
<template>
  <div :class="prefixCls" class="app-template-show wh100b">
    <frameHeader showType="template" :appId="appId" :back="false"></frameHeader>
    <frameBody  :itemMenu="itemMenu"></frameBody>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "app-template-show",
});
</script>

<script lang="ts" setup>
import FrameBody from './appFrame/appFrameCom/frameBody.vue';
import FrameHeader from './appFrame/appFrameCom/frameHeader.vue';
import {useDesign} from "@/hooks/web/useDesign";
import {usePostMessage} from "@/hooks/web/usePostMessage";
import {getUrlParams, StorageUtils} from 'xmgoing-utils';
import {getAppObjByTemplateId} from "@/api/sys/portalSpace";
import {nextTick, ref, unref} from "vue";
import {usePcSpaceStore} from "@/store/pcSpaceStore";
import {useRouter} from "vue-router";

const {prefixCls} = useDesign('app-template-show');
const {closeTempMsg}=usePostMessage();
const itemMenu = ref({});
const pcSpaceStore = usePcSpaceStore();
const appId:any = ref('');
const router = useRouter();

/**
 * 打开界面
 * @param item
 */
const openPageByTemplateItem = ({item}, backFun) => {
  itemMenu.value = item;
  StorageUtils.addSessionItem('curAppItem', JSON.stringify(unref(item)));
  if(item.appId+""==='-1'){
    appId.value = getUrlParams("appId",true);
  }else{
    appId.value = item.appId;
  }
  if(appId.value){
    StorageUtils.addSessionItem('appId',appId.value);
    StorageUtils.addSessionItem('appid',appId.value);
  }

  //查询当前应用对应的门户信息
  if((item.appId+'')==='-1'){
    item.appId=appId.value;
  }
  //如果应用id不存在
  if((item.appId==null||item.appId==="null"||(item.appId+'')==='-1')&&StorageUtils.getSessionItem("appId")){
    item.appId=StorageUtils.getSessionItem("appId");
  }
  //如果模版应用id存在
  if((item.appId==null||item.appId==="null"||(item.appId+'')==='-1')&&StorageUtils.getSessionItem("templateAppId")){
    item.appId=StorageUtils.getSessionItem("templateAppId");
  }
  StorageUtils.addSessionItem("templateAppId",item.appId);
  pcSpaceStore.getPcSpaceByAppIdAction(item.appId).then(() => {
    StorageUtils.addSessionItem("curAppId", item.appId);
    nextTick(() => {
      router.push({path: '/dashboard/appMainPage'});
      backFun && backFun();
    })
  });
}


/**
 * 根据模版id 获取菜单相关信息
 */
const openPageByTemplateId = async function (templateId) {
  const item = await getAppObjByTemplateId(templateId + "");
  if (item && item[0]) {
    openPageByTemplateItem({item: item[0]}, () => {});
  }else{
    openPageByTemplateItem({item: {}}, () => {});
  }
}

const templateId=getUrlParams("templateId",true)||StorageUtils.getSessionItem("templateId");
if(templateId){
  StorageUtils.addSessionItem("templateId",templateId)
  openPageByTemplateId(templateId);
}

nextTick(()=>{
  closeTempMsg();
})
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-app-template-show';

.@{prefix-cls} {

}
</style>
